import { Companion_getInstance138pnyl3l6agm as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  OffsetInfo3e2qnmrj9hm5p as OffsetInfo,
  Regular3ayyei7bjphdz as Regular,
} from './OffsetInfo.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toLocalDateTime1cof646mhw5l9 as toLocalDateTime } from '../TimeZone.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  first58ocm7j58k3q as first,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { binarySearch1nmlzx9onl5pm as binarySearch } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function offsetInfoForTransitionIndex($this, transitionIndex) {
  var transitionInstant = Companion_getInstance().fromEpochSeconds$default_a0tgtu_k$($this.transitionEpochSeconds_1.get_c1px32_k$(transitionIndex));
  var offsetBefore = $this.offsets_1.get_c1px32_k$(transitionIndex);
  var offsetAfter = $this.offsets_1.get_c1px32_k$(transitionIndex + 1 | 0);
  return OffsetInfo(transitionInstant, offsetBefore, offsetAfter);
}
var TimeZoneRulesCommonClass;
function TimeZoneRulesCommon() {
  if (TimeZoneRulesCommonClass === VOID) {
    class $ {
      constructor(transitionEpochSeconds, offsets, recurringZoneRules) {
        this.transitionEpochSeconds_1 = transitionEpochSeconds;
        this.offsets_1 = offsets;
        this.recurringZoneRules_1 = recurringZoneRules;
        // Inline function 'kotlin.require' call
        if (!(this.offsets_1.get_size_woubt6_k$() === (this.transitionEpochSeconds_1.get_size_woubt6_k$() + 1 | 0))) {
          var message = 'offsets.size must be one more than transitionEpochSeconds.size';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var tmp = this;
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var inductionVariable = 0;
        var last = this.transitionEpochSeconds_1.get_size_woubt6_k$() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var instant = Companion_getInstance().fromEpochSeconds$default_a0tgtu_k$(this.transitionEpochSeconds_1.get_c1px32_k$(i));
            var ldtBefore = toLocalDateTime(instant, this.offsets_1.get_c1px32_k$(i));
            var ldtAfter = toLocalDateTime(instant, this.offsets_1.get_c1px32_k$(i + 1 | 0));
            if (ldtBefore.compareTo_c32ujr_k$(ldtAfter) < 0) {
              this_0.add_utx5q5_k$(ldtBefore);
              this_0.add_utx5q5_k$(ldtAfter);
            } else {
              this_0.add_utx5q5_k$(ldtAfter);
              this_0.add_utx5q5_k$(ldtBefore);
            }
          }
           while (inductionVariable <= last);
        tmp.transitionLocalDateTimes_1 = this_0.build_nmwvly_k$();
      }
      infoAtInstant_1jk5uc_k$(instant) {
        var epochSeconds = instant.epochSeconds_1;
        var tmp;
        if (!(this.recurringZoneRules_1 == null)) {
          var tmp0_safe_receiver = lastOrNull(this.transitionEpochSeconds_1);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = epochSeconds >= tmp0_safe_receiver;
          }
          tmp = !(tmp_0 === false);
        } else {
          tmp = false;
        }
        if (tmp) {
          return this.recurringZoneRules_1.infoAtInstant_d1lv6l_k$(instant, last(this.offsets_1));
        }
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = binarySearch(this.transitionEpochSeconds_1, epochSeconds) + 1 | 0;
        var index = abs(this_0);
        return this.offsets_1.get_c1px32_k$(index);
      }
      infoAtDatetime_we6d2t_k$(localDateTime) {
        var tmp;
        if (!(this.recurringZoneRules_1 == null)) {
          var tmp0_safe_receiver = lastOrNull(this.transitionLocalDateTimes_1);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = localDateTime.compareTo_c32ujr_k$(tmp0_safe_receiver) > 0;
          }
          tmp = !(tmp_0 === false);
        } else {
          tmp = false;
        }
        if (tmp) {
          return this.recurringZoneRules_1.infoAtLocalDateTime_mf6rlz_k$(localDateTime, last(this.offsets_1));
        }
        // Inline function 'kotlin.let' call
        var it = binarySearch(this.transitionLocalDateTimes_1, localDateTime);
        var lastIndexNotBiggerThanLdt = it < 0 ? (-it | 0) - 2 | 0 : it;
        if (lastIndexNotBiggerThanLdt === -1) {
          return new (Regular())(first(this.offsets_1));
        }
        var tmp_1;
        if ((lastIndexNotBiggerThanLdt % 2 | 0) === 0) {
          tmp_1 = offsetInfoForTransitionIndex(this, lastIndexNotBiggerThanLdt / 2 | 0);
        } else if (!(lastIndexNotBiggerThanLdt === (this.transitionLocalDateTimes_1.get_size_woubt6_k$() - 1 | 0)) && this.transitionLocalDateTimes_1.get_c1px32_k$(lastIndexNotBiggerThanLdt).equals(this.transitionLocalDateTimes_1.get_c1px32_k$(lastIndexNotBiggerThanLdt + 1 | 0))) {
          tmp_1 = offsetInfoForTransitionIndex(this, (lastIndexNotBiggerThanLdt / 2 | 0) + 1 | 0);
        } else {
          tmp_1 = new (Regular())(this.offsets_1.get_c1px32_k$((lastIndexNotBiggerThanLdt / 2 | 0) + 1 | 0));
        }
        return tmp_1;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var inductionVariable = 0;
        var last_0 = this.transitionEpochSeconds_1.get_size_woubt6_k$() - 1 | 0;
        if (inductionVariable <= last_0)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this_0.append_t8pm91_k$(this.offsets_1.get_c1px32_k$(i));
            this_0.append_22ad7x_k$(' until ');
            this_0.append_t8pm91_k$(Companion_getInstance().fromEpochSeconds$default_a0tgtu_k$(this.transitionEpochSeconds_1.get_c1px32_k$(i)));
            this_0.append_22ad7x_k$(', ');
          }
           while (inductionVariable <= last_0);
        this_0.append_22ad7x_k$('then ');
        this_0.append_t8pm91_k$(last(this.offsets_1));
        if (!(this.recurringZoneRules_1 == null)) {
          this_0.append_22ad7x_k$(', after that ');
          this_0.append_t8pm91_k$(this.recurringZoneRules_1);
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'TimeZoneRulesCommon');
    TimeZoneRulesCommonClass = $;
  }
  return TimeZoneRulesCommonClass;
}
var RuleClass;
function Rule() {
  if (RuleClass === VOID) {
    class $ {
      constructor(transitionDateTime, offsetBefore, offsetAfter) {
        this.transitionDateTime_1 = transitionDateTime;
        this.offsetBefore_1 = offsetBefore;
        this.offsetAfter_1 = offsetAfter;
      }
      toString() {
        return 'transitioning from ' + this.offsetBefore_1.toString() + ' to ' + this.offsetAfter_1.toString() + ' on ' + toString_0(this.transitionDateTime_1);
      }
    }
    initMetadataForClass($, 'Rule');
    RuleClass = $;
  }
  return RuleClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function RecurringZoneRules$rulesForYear$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.transitionDateTime_1;
  var tmp$ret$2 = b.transitionDateTime_1;
  return compareValues(tmp, tmp$ret$2);
}
//region block: exports
export {
  TimeZoneRulesCommon as TimeZoneRulesCommon3vpcb22l6ddoq,
};
//endregion

//# sourceMappingURL=TimeZoneRules.mjs.map
